//User Register Action Type
export const USER_REGISTER_RESET_FORM = "USER_REGISTER_RESET_FORM"
export const USER_REGISTER_SET_NAME = "USER_REGISTER_SET_NAME"
export const USER_REGISTER_SET_DATE_BIRTH = "USER_REGISTER_SET_DATE_BIRTH"
export const USER_REGISTER_SET_HANDPHONE_NUMBER = "USER_REGISTER_SET_HANDPHONE_NUMBER"
export const USER_REGISTER_SET_GENDER = "USER_REGISTER_SET_GENDER"
export const USER_REGISTER_SET_EMAIL = "USER_REGISTER_SET_EMAIL"
export const USER_REGISTER_SET_PASSWORD = "USER_REGISTER_SET_PASSWORD"
export const USER_REGISTER_SET_ERROR_MESSAGE = "USER_REGISTER_SET_ERROR_MESSAGE"
export const USER_REGISTER_SET_SUCCES_MESSAGE = "USER_REGISTER_SET_SUCCES_MESSAGE"
export const USER_REGISTER_START_LOADING = "USER_REGISTER_START_LOADING"
export const USER_REGISTER_STOP_LOADING = "USER_REGISTER_STOP_LOADING"

//User Login Action Type

export const USER_LOGIN_RESET_FORM = "USER_LOGIN_RESET_FORM"
export const USER_LOGIN_SET_EMAIL = "USER_LOGIN_SET_EMAIL"
export const USER_LOGIN_SET_PASSWORD = "USER_LOGIN_SET_PASSWORD"
export const USER_LOGIN_SET_ERROR_MESSAGE = "USER_LOGIN_SET_ERROR_MESSAGE"
export const USER_LOGIN_START_LOADING = "USER_LOGIN_START_LOADING"
export const USER_LOGIN_STOP_LOADING = "USER_LOGIN_STOP_LOADING"
export const USER_LOGIN_SET_ACCESS_TOKEN = "USER_LOGIN_SET_ACCESS_TOKEN"
export const USER_LOGIN_SET_LOGIN = "USER_LOGIN_SET_LOGIN"
export const USER_LOGIN_SET_LOGOUT = "USER_LOGIN_SET_LOGOUT"

// USER Profile Action Type
export const USER_PROFILE_SET_USER_ID = "USER_PROFILE_SET_USER_ID"
export const USER_PROFILE_SET_NAME = "USER_PROFILE_SET_NAME"
export const USER_PROFILE_SET_DATE_BIRTH = "USER_PROFILE_SET_DATE_BIRTH"
export const USER_PROFILE_SET_HANDPHONE_NUMBER = "USER_PROFILE_SET_HANDPHONE_NUMBER"
export const USER_PROFILE_SET_GENDER = "USER_PROFILE_SET_GENDER"
export const USER_PROFILE_SET_EMAIL = "USER_PROFILE_SET_EMAIL"
export const USER_PROFILE_SET_ERROR_MESSAGE = "USER_PROFILE_SET_ERROR_MESSAGE"
export const USER_PROFILE_START_LOADING = "USER_PROFILE_START_LOADING"
export const USER_PROFILE_STOP_LOADING = "USER_PROFILE_STOP_LOADING"
